module.exports = __webpack_public_path__ + "img/header-weddingRingsDiamonds@2x.7af01bd.webp";